export default function About() {
  return (
    <section id="about" className="bg-white text-[#0f172a] py-24 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6 space-y-6">
            <span className="text-xs font-bold uppercase tracking-widest text-[#1e3a8a] block">About Anas Enterprises</span>
            <h2 className="display-font text-4xl sm:text-5xl uppercase tracking-tight text-[#0f172a]">
              Dedicated Civil Interior &amp; Floor Specialists
            </h2>
            <p className="text-slate-600 text-sm leading-relaxed">
              Headquartered in Malad East, Anas Enterprises Civil Interior Contractor provides dedicated marble restoration, granite polishing, crack fusion, and tile fitting for homeowners, housing societies, architects, and builders throughout Mumbai.
            </p>
            <div className="border-l-4 border-[#1e3a8a] pl-4 space-y-1">
              <span className="text-xs font-bold uppercase tracking-wider text-slate-900 block">Our Craft Standard</span>
              <p className="text-xs text-slate-600">Zero swirl marks, uniform mirror reflectance, and invisible crack fillings guaranteed on every floor handover.</p>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div
              data-testid="testimonials-placeholder"
              className="bg-[#f8fafc] border border-dashed border-slate-300 rounded-lg p-8 text-center space-y-4"
            >
              <div className="w-12 h-12 bg-blue-100 text-[#1e3a8a] rounded-full flex items-center justify-center mx-auto">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                </svg>
              </div>
              <h3 className="font-bold text-slate-900 text-sm uppercase tracking-wider">Client Reviews &amp; Testimonials</h3>
              <p className="text-xs text-slate-500 max-w-sm mx-auto">
                Verified client reviews from our Mumbai residential societies and architect partners will be published directly here.
              </p>
              <span className="inline-block text-[10px] uppercase tracking-widest font-mono text-slate-400">Authentic Project Feedback Hub</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
